import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Navigation, MessageCircle, CalendarCheck, Clock } from "lucide-react";
import { CLINIC, NAV_LINKS, whatsappLink } from "../lib/constants";
import { Logo } from "./Navbar";

export const Footer = () => (
  <footer className="bg-ink-deep text-white noise-dark" data-testid="site-footer">
    <div className="relative container-x pt-16 pb-8">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo light />
          <p className="mt-5 font-serif italic text-lg text-blue-200/90">{CLINIC.tagline}</p>
          <p className="mt-3 text-xs text-blue-200/60 leading-relaxed">
            Retina & Cataract Specialist Centre — Janak Puri, New Delhi. Established {CLINIC.established}.
          </p>
          <a
            href={CLINIC.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-blue-100 hover:text-aqua-bright transition-colors"
            data-testid="footer-instagram-link"
          >
            <Instagram className="w-4 h-4" aria-hidden="true" /> @{CLINIC.instagramHandle}
          </a>
        </div>
        <nav aria-label="Footer">
          <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-aqua-bright">Quick Links</h3>
          <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-blue-100/80 hover:text-white transition-colors" data-testid={`footer-link-${l.label.toLowerCase()}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-aqua-bright">Contact</h3>
          <ul className="mt-5 space-y-3.5 text-sm text-blue-100/80">
            <li>
              <a href={CLINIC.phoneLink} className="flex items-center gap-2.5 hover:text-white transition-colors" data-testid="footer-phone-link">
                <Phone className="w-4 h-4 text-aqua-bright shrink-0" aria-hidden="true" /> {CLINIC.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={CLINIC.emailLink} className="flex items-center gap-2.5 hover:text-white transition-colors" data-testid="footer-email-link">
                <Mail className="w-4 h-4 text-aqua-bright shrink-0" aria-hidden="true" /> {CLINIC.email}
              </a>
            </li>
            <li className="flex items-start gap-2.5">
              <MapPin className="w-4 h-4 text-aqua-bright shrink-0 mt-0.5" aria-hidden="true" />
              <span>
                {CLINIC.addressLines.map((l) => (
                  <span key={l} className="block">{l}</span>
                ))}
              </span>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-aqua-bright">Opening Hours</h3>
          <ul className="mt-5 space-y-3 text-sm text-blue-100/80">
            {CLINIC.hours.map((h) => (
              <li key={h.days} className="flex items-start gap-2.5">
                <Clock className="w-4 h-4 text-aqua-bright shrink-0 mt-0.5" aria-hidden="true" />
                <span>
                  <span className="block font-semibold text-blue-50">{h.days}</span>
                  {h.time}
                </span>
              </li>
            ))}
            <li className="text-xs text-blue-200/60 pt-1">Open 7 days a week · No regular holiday</li>
          </ul>
        </div>
      </div>
      <div className="mt-14 flex flex-col sm:flex-row flex-wrap gap-3">
        <Link to="/contact#book" className="btn-primary !bg-aqua hover:!bg-aqua-bright flex-1 sm:flex-none justify-center" data-testid="footer-book-button">
          <CalendarCheck className="w-4 h-4" aria-hidden="true" /> Book Appointment
        </Link>
        <a href={CLINIC.phoneLink} className="btn-outline !bg-transparent !text-white !border-white/25 hover:!border-white flex-1 sm:flex-none justify-center" data-testid="footer-call-button">
          <Phone className="w-4 h-4" aria-hidden="true" /> Call Now
        </a>
        <a href={whatsappLink("Hello iNetra, I would like to book an appointment.")} target="_blank" rel="noopener noreferrer" className="btn-outline !bg-transparent !text-white !border-white/25 hover:!border-white flex-1 sm:flex-none justify-center" data-testid="footer-whatsapp-button">
          <MessageCircle className="w-4 h-4" aria-hidden="true" /> WhatsApp
        </a>
        <a href={CLINIC.directionsUrl} target="_blank" rel="noopener noreferrer" className="btn-outline !bg-transparent !text-white !border-white/25 hover:!border-white flex-1 sm:flex-none justify-center" data-testid="footer-directions-button">
          <Navigation className="w-4 h-4" aria-hidden="true" /> Get Directions
        </a>
      </div>
      <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-blue-200/50">
        <p>© {new Date().getFullYear()} {CLINIC.fullName}. All rights reserved.</p>
        <p>Retina & Cataract Specialist Centre · Janak Puri, New Delhi</p>
      </div>
    </div>
  </footer>
);
